
// services/SubscriptionService.js - FIXED imports
import { BaseService } from './BaseService';
import { Subscription, QuickUsageStats, Usage } from '../models';

export class SubscriptionService extends BaseService {
  constructor() {
    super();
  }

  async getSubscriptionStatus() {
    const response = await this.get('/subscriptions/status');
    return {
      subscription: new Subscription(response.data.subscription),
      usageStats: new Usage(response.data.usageStats) // Changed from UsageStats to Usage
    };
  }

  async getSubscriptionPlans() {
    const response = await this.get('/subscriptions/plans');
    return response.data.plans;
  }

  async getUsageQuickCheck() {
    const response = await this.get('/subscriptions/usage/quick-check');
    return new QuickUsageStats(response.data);
  }



  async updateSubscription(planType) {
    const response = await this.put('/subscriptions', { planType });
    return new Subscription(response.data.subscription);
  }

  async cancelSubscription() {
    const response = await this.delete('/subscriptions');
    return response.data;
  }

  async validatePromoCode(code) {
    const response = await this.post('/stripe/validate-promo', { code });
    return response.data;
  }

  async createCheckoutSession(planType, promoCode) {
    const response = await this.post('/stripe/checkout', { planType, promoCode });
    return response.data;
  }

  async getPortalUrl() {
    const response = await this.post('/stripe/portal');
    return response.data;
  }

  async verifySession(sessionId) {
    const response = await this.get(`/stripe/verify-session?session_id=${encodeURIComponent(sessionId)}`);
    return response.data;
  }
 
  async getCurrentSubscription() {
    const response = await this.get('/stripe/current-subscription');
    return response.data; // { subscription: { ... } }
  }

  /**
   * Verify Apple IAP receipt with backend
   * @param {string} receiptData - Base64 encoded receipt from Apple
   * @returns {Promise<Object>} Response with subscription status
   */
  async verifyAppleReceipt(receiptData) {
    const response = await this.post('/apple-iap/verify-receipt', { receiptData });
    return response.data;
    // Response schema:
    // {
    //   subscription: {
    //     isActive: boolean,
    //     expiresDate: string,
    //     productId: string,
    //     autoRenewStatus: boolean,
    //     isTrialPeriod: boolean,
    //     environment: string
    //   },
    //   message: string
    // }
  }

  /**
   * Link Apple IAP transaction to the current user
   * This allows Apple webhooks to find the user for future subscription events
   * @param {string} originalTransactionId - The original transaction ID from StoreKit
   * @returns {Promise<Object>} Response with success status
   */
  async linkTransaction(originalTransactionId, transactionDetails = {}) {
    const response = await this.post('/apple-iap/link-transaction', {
      originalTransactionId,
      ...transactionDetails
    });
    return response;
    // Response schema:
    // {
    //   success: true,
    //   data: {
    //     message: "Transaction linked successfully"
    //   }
    // }
  }

}